export const attachedEnvironmentsColumns = [
  {
    header: 'name',
    accessor: 'name',
    styles: { width: '200px', cell: { maxWidth: '200px' } },
  },
];
